import React from "react";
import AnalysisWidget from "./AnalysisWidget.jsx";

export function Journalist({
  widgetParams,
  feedsParams,
  setFeedsParams,
  setShowFeedsList,
  applyFilterTS,
  widgetList,
  embededEnabled,
}) {
  if (!widgetParams || !Object.keys(widgetParams).length) {
    return null;
  }
  const vertical = widgetParams.selectedVertical;
  let tempWidgetList = [...widgetList];
  if (Array.isArray(vertical)) {
    tempWidgetList = tempWidgetList.filter((w) => {
      if (
        vertical.indexOf(w.type.toString()) !== -1 ||
        vertical.indexOf(w.type) !== -1
      ) {
        return w;
      }
      return null;
    });
  }

  return (
    <React.Fragment key={vertical}>
      {tempWidgetList &&
        tempWidgetList.map((w) => {
          return (
            <AnalysisWidget
              widgetParams={{ ...w, ...widgetParams }}
              feedsParams={feedsParams}
              setFeedsParams={setFeedsParams}
              setShowFeedsList={setShowFeedsList}
              applyFilterTS={applyFilterTS}
              embededEnabled={embededEnabled}
            />
          );
        })}
    </React.Fragment>
  );
}
